import { FC, createContext, useMemo, useContext, ReactNode } from "react";

import useMedia from "use-media";

import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const MediaQueryContext = createContext({
  isMobile: false,
  isTablet: false,
  isDesktop: false,
});

type mediaType = {
  children?: ReactNode;
};

export const MediaQueryProvider: FC<mediaType> = ({ children }) => {
  const isMobile = useMedia(MEDIA_QUERIES.MOBILE);
  const isTablet = useMedia(MEDIA_QUERIES.TABLET);
  const isDesktop = useMedia(MEDIA_QUERIES.DESKTOP);

  const values = useMemo(() => ({ isMobile, isTablet, isDesktop }), [
    isMobile,
    isTablet,
    isDesktop,
  ]);

  return (
    <MediaQueryContext.Provider value={values}>
      {children}
    </MediaQueryContext.Provider>
  );
};

export const useMediaQuery = (): {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
} => useContext(MediaQueryContext);
